import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const DASHBOARD_HOME_ROUTE = "team";
const SKIP_HOME_ROUTE = "checklist";
const ONBOARDING_HOME_ROUTE = "uploadimage";

const PUBLIC_ROUTE_NAMES = new Set([
  "onboardingscreen",
  "signup",
  "signupemail",
  "enteremail",
  "verifyotp",
  "passkey",
  "forgotpassword",
  "verifyforgotpasswordotp",
  "resetpassword",
  "readonlycontract",
  "generalcontract",
  "checklist",
  "checklistuser",
  "checklistTourDemo",
]);

const ROUTES_ALLOWED_FOR_ALL_STATES = new Set([
  "readonlycontract",
  "generalcontract",
  "welcome",
  "checklist",
  "checklistuser",
  "checklistTourDemo",
]);

const ONBOARDING_ONLY_ROUTE_NAMES = new Set([
  "uploadimage",
  "color",
  "pushnotification",
  "peopleyouknow",
  "hereaboutus",
  "payment",
  "paymenttype",
  "checklist",
  "checklistuser",
  "checklistTourDemo",
]);

const ONBOARDING_ALLOWED_ROUTE_NAMES = new Set([
  ...ONBOARDING_ONLY_ROUTE_NAMES,
  "sendrequests",
  "sendrequestswithoutorg",
]);

const SKIP_USER_ROUTE_NAMES = new Set([
  "checklist",
  "memberchecklist",
  "notification",
  "readonlycontract",
  "generalcontract",
  "myprofile",
  "profile",
  "changeplan",
  "sendrequests",
  "sendrequestswithoutorg",
  "payment",
  "paymenttype",
]);

const matchesRoute = (route, collection) => {
  if (!route) {
    return false;
  }
  if (route.name && collection.has(route.name)) {
    return true;
  }
  return false;
};

const routes = [
  {
    path: "*",
    redirect: "/onboardingscreen",
  },
  {
    path: "/",
    name: "/",
    component: () => import("../Layouts/AuthLayout.vue"),
    redirect: "/onboardingscreen",
    children: [
      {
        path: "/signup",
        name: "signup",
        component: () => import("../views/auth/signup.vue"),
      },
      {
        path: "/signup-email",
        name: "signupemail",
        component: () => import("../views/auth/signup-email.vue"),
      },
      {
        path: "/enter-email",
        name: "enteremail",
        component: () => import("../views/auth/enter-email.vue"),
      },
      {
        path: "/forgot-password",
        name: "forgotpassword",
        component: () => import("../views/auth/forgot-password.vue"),
      },
      {
        path: "/verify-forgot-password-otp",
        name: "verifyforgotpasswordotp",
        component: () => import("../views/auth/verify-forgot-password-otp.vue"),
      },
      {
        path: "/reset-password",
        name: "resetpassword",
        component: () => import("../views/auth/reset-password.vue"),
      },
      {
        path: "/verify-otp",
        name: "verifyotp",
        component: () => import("../views/auth/verify-otp.vue"),
      },
      {
        path: "/passkey",
        name: "passkey",
        component: () => import("../views/auth/passkey.vue"),
      },
    ],
  },
  {
    path: "/dashboard",
    component: () => import("../Layouts/AdminLayout.vue"),
    redirect: "/team",
    children: [
      {
        path: "/team",
        name: "team",
        component: () => import("../views/team/index.vue"),
      },
      {
        path: "/team/teamprofile",
        name: "teamprofile",
        component: () => import("../views/team/teamprofile.vue"),
      },
      {
        path: "/team/teamprofile/checklist",
        name: "teamprofilechecklist",
        component: () => import("../views/team/checklist.vue"),
      },
      {
        path: "/checklist",
        name: "checklist",
        component: () => import("../views/checklist/index.vue"),
      },
      {
        path: "/memberchecklist/:id",
        name: "memberchecklist",
        component: () => import("../views/member/memberchecklist.vue"),
      },
      {
        path: "/checklist/contract",
        name: "checklistContract",
        component: () => import("../views/checklist/contract.vue"),
      },
      {
        path: "/checklist/editcontract",
        name: "editchecklistContract",
        component: () => import("../views/checklist/editcontract.vue"),
      },
      {
        path: "/checklist/user",
        name: "checklistuser",
        component: () => import("../views/checklist/user.vue"),
      },
      {
        path: "/checklist/tour-demo",
        name: "checklistTourDemo",
        component: () => import("../views/checklist/user.vue"),
      },
      {
        path: "/team/user",
        name: "teamuser",
        component: () => import("../views/team/checklistinfo.vue"),
      },
      {
        path: "/notification",
        name: "notification",
        component: () => import("../views/notification/index.vue"),
      },
      {
        path: "/template",
        name: "template",
        component: () => import("../views/template/index.vue"),
      },
      {
        path: "/template/tasks",
        name: "temptasks",
        component: () => import("../views/template/tasks.vue"),
      },
      {
        path: "/member",
        name: "member",
        component: () => import("../views/member/index.vue"),
      },
      {
        path: "/chats",
        name: "chats",
        component: () => import("../views/chats/index.vue"),
      },
    ],
  },
  {
    path: "/checklist/readonly/:contractId",
    name: "readonlycontract",
    component: () => import("../views/checklist/readonlycontract.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/profile/index.vue"),
  },
  {
    path: "/myprofile",
    name: "myprofile",
    component: () => import("../components/Profile/myprofile.vue"),
  },
  {
    path: "/profile/changeplan",
    name: "changeplan",
    component: () => import("../views/profile/changeplan.vue"),
  },
  {
    path: "/onboardingscreen",
    name: "onboardingscreen",
    component: () => import("../views/onboardingscreen/index.vue"),
  },
  {
    path: "/payment",
    name: "payment",
    component: () => import("../views/onboardingscreen/payment.vue"),
  },
  {
    path: "/payment/paymenttype",
    name: "paymenttype",
    component: () => import("../views/onboardingscreen/paymenttype.vue"),
  },
  {
    path: "/uploadimage",
    name: "uploadimage",
    component: () => import("../views/onboardingscreen/uploadimage.vue"),
  },
  {
    path: "/color",
    name: "color",
    component: () => import("../views/onboardingscreen/color.vue"),
  },
  {
    path: "/pushnotification",
    name: "pushnotification",
    component: () => import("../views/onboardingscreen/notification.vue"),
  },
  {
    path: "/peopleyouknow",
    name: "peopleyouknow",
    component: () => import("../views/onboardingscreen/peopleyouknow.vue"),
  },
  {
    path: "/hereaboutus",
    name: "hereaboutus",
    component: () => import("../views/onboardingscreen/hereaboutus.vue"),
  },
  {
    path: "/generalcontract",
    name: "generalcontract",
    component: () => import("../views/GlobalLink/index.vue"),
  },
  {
    path: "/welcome",
    name: "welcome",
    component: () => import("../views/onboardingscreen/welcome.vue"),
  },
  {
    path: "/sendrequests",
    name: "sendrequests",
    component: () => import("../views/onboardingscreen/SendRequests.vue"),
  },
  {
    path: "/sendrequestswithoutorg",
    name: "sendrequestswithoutorg",
    component: () =>
      import("../views/onboardingscreen/SendRequestWitoutOrg.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
let previousRoute = null;

router.beforeEach((to, from, next) => {
  previousRoute = from;
  const accessToken = localStorage.getItem("userToken");
  const skipPayment = localStorage.getItem("skipPayment") === "true";
  const onboardingFlag = localStorage.getItem("alreadyExist");
  const isExplicitOnboardingUser = onboardingFlag === "no" && !skipPayment;
  const hasCompletedOnboarding =
    onboardingFlag === "yes" || (!onboardingFlag && !skipPayment);

  if (!accessToken) {
    if (matchesRoute(to, PUBLIC_ROUTE_NAMES)) {
      return next();
    }
    return next({ name: "onboardingscreen" });
  }

  if (matchesRoute(to, ROUTES_ALLOWED_FOR_ALL_STATES)) {
    return next();
  }

  if (matchesRoute(to, PUBLIC_ROUTE_NAMES)) {
    const fallback = skipPayment
      ? SKIP_HOME_ROUTE
      : hasCompletedOnboarding
      ? DASHBOARD_HOME_ROUTE
      : ONBOARDING_HOME_ROUTE;
    return next({ name: fallback });
  }

  if (skipPayment) {
    if (!matchesRoute(to, SKIP_USER_ROUTE_NAMES)) {
      return next({ name: SKIP_HOME_ROUTE });
    }
    return next();
  }

  if (hasCompletedOnboarding && matchesRoute(to, ONBOARDING_ONLY_ROUTE_NAMES)) {
    return next({ name: DASHBOARD_HOME_ROUTE });
  }

  if (
    isExplicitOnboardingUser &&
    !matchesRoute(to, ONBOARDING_ALLOWED_ROUTE_NAMES)
  ) {
    return next({ name: ONBOARDING_HOME_ROUTE });
  }

  return next();
});

Vue.prototype.$getPreviousRoute = () => previousRoute;
export default router;
